var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social"
  }, [_c('nav', _vm._l((_vm.services), function(attributes, service) {
    return _c('a', {
      class: _vm.linkClassList(service),
      attrs: {
        "href": "#",
        "title": service
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleService(service)
        }
      }
    }, [_vm._v(_vm._s(service))])
  })), _vm._v(" "), _c('section', _vm._l((_vm.services), function(attributes, service) {
    return (attributes.value != null) ? _c('article', [_c('i', {
      staticClass: "ss-icon ss-social-regular",
      attrs: {
        "title": service
      }
    }, [_vm._v(_vm._s(service))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attributes.value),
        expression: "attributes.value"
      }],
      staticClass: "cm-field",
      attrs: {
        "type": "text",
        "name": _vm.serviceName(service),
        "placeholder": attributes.placeholder
      },
      domProps: {
        "value": (attributes.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          attributes.value = $event.target.value
        }
      }
    })]) : _vm._e()
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-663c9e71","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/social-links.vue
// module id = null
// module chunks = 